import Cookies from "js-cookie";
import CONFIG from "./config";
// import qs from 'qs'

const saveAccessToken = (token) => {
    return Cookies.set(CONFIG.COOKIES_NAME_AUTH, token);
};

const getAccessToken = () => {
    return Cookies.get(CONFIG.COOKIES_NAME_AUTH);
};

const purgeAccessToken = () => {
    return Cookies.remove(CONFIG.COOKIES_NAME_AUTH);
}

const saveRefreshToken = (token) => {
    return Cookies.set('refresh', token);
};

const getRefreshToken = () => {
    return Cookies.get('refresh');
};

const purgeRefreshToken = () => {
    return Cookies.remove('refresh');
}

const saveMe = (me) => {
    return Cookies.set('me', me);
};

const getMe = () => {
    // console.log(JS   ON.stringify(Cookies.get('me')))
    return Cookies.get('me');
};

const purgeMe = () => {
    return Cookies.remove('me');
}

export { saveAccessToken, getAccessToken, purgeAccessToken, saveRefreshToken, getRefreshToken, purgeRefreshToken, saveMe, getMe, purgeMe };